import MyZGO from './MyZGO'

export default MyZGO
